import React from 'react';
import { useCurrentMembership } from '@identity/hooks';
import { useParams } from '@common/hooks';
import { Col, Row } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import { AppContent } from '@common/components';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import {
  AccountSettingsMenu,
  ChangePasswordSection,
  NotificationsSection,
  UserSettings,
} from './account-settings';

export function AccountSettingsPage() {
  const { page } = useParams<{
    page: 'change-password' | 'notifications' | 'user-settings';
  }>();
  const currentMembership = useCurrentMembership();

  setBreadcrumbs([
    { name: 'Account Settings', path: '/works/account-settings' },
  ]);

  const pagesContent = {
    'user-settings': <UserSettings />,
    'change-password': <ChangePasswordSection />,
    notifications: (
      <NotificationsSection
        allowEmailNotifications={currentMembership.allowEmailNotifications}
        notificationCategories={currentMembership.notificationCategories}
        notifications={currentMembership.notifications || []}
      />
    ),
  };

  return (
    <AppContent>
      <div className="account-settings">
        <Row gutter={24}>
          <Col xxl={{ span: 6 }} xs={{ span: 8 }} sm={{ span: 8 }}>
            <AccountSettingsMenu />
          </Col>
          <Col xxl={{ span: 18 }} xs={{ span: 16 }} sm={{ span: 16 }}>
            {pagesContent[page || 'user-settings']}
          </Col>
        </Row>

        <style jsx>{`
          .account-settings :global(.ant-input-prefix) {
            color: ${Colors.steelDarker};
          }

          .account-settings :global(input[type='password']) {
            padding-left: 0.3rem;
          }

          .account-settings :global(.ant-menu) {
            margin-top: 24px;
            border: none;
          }

          .account-settings :global(.ant-menu-item) {
            margin: 0;
            font-size: 16px;
            border-radius: 8px;
            display: flex;
            align-items: center;
          }

          .account-settings :global(.ant-menu-item > .ant-menu-title-content) {
            width: 100%;
          }

          .account-settings :global(.ant-menu-item a),
          .account-settings__profile-menu-item__link {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          }
        `}</style>
      </div>
    </AppContent>
  );
}
